import React from 'react';
import clsx from 'clsx';
import dayjs from 'dayjs';
import ScrollToTopButton from '../../Common/ScrollToTopButton';
import { InstagramGreenIcon, LinkedInGreenIcon } from '../../Common/Icon';
import { navLinks } from '../Header';

import styles from './index.module.scss';

const links = [
  { text: 'Impressum', link: 'https://www.sephyre.com/impressum/' },
  { text: 'Datenschutz', link: 'https://www.sephyre.com/datenschutz/' },
  { text: 'AGB', link: 'https://www.sephyre.com/wp-content/uploads/2025/05/AGB-Sephyre_16.-Mai-2025.pdf' },
];

function SocialsContent() {
  return (
    <>
      <a href="https://www.instagram.com/sephyrelogistics/">
        <InstagramGreenIcon className={styles.logoSocial} />
        {/* <img src="/media/ic-instagram.png" alt="logo" className={styles.logo} /> */}
      </a>
      <a href="https://www.linkedin.com/company/sephyre-logistics">
        <LinkedInGreenIcon className={styles.logoSocial} />
        {/* <img src="/media/linkedin.png" alt="Logo" className={styles.logo} /> */}
      </a>
    </>
  );
}

export default function Footer(): React.ReactNode {
  return (
    <div className={styles.footer}>
      <div>
        <a href="https://www.sephyre.com/">
          <img src="/media/logo-light.png" alt="Logo" className={styles.logo} />
        </a>
      </div>

      <div className={styles.navigation}>
        <div className={styles.companyInfo}>
          <div className={clsx(styles.text_lg)}>
            <p>Sephyre GmbH</p>
            <p>CH-4450 Sissach</p>
            <span>Schweiz</span>
          </div>
          <div className={clsx(styles.text_md, styles.column, styles.section2)}>
            <a href="tel:+41619111616" style={{ marginTop: '30px' }}>+41 61 911 16 16</a>
            <a href="mailto:welcome@sephyre.com">welcome@sephyre.com</a>
          </div>
        </div>

        <div className={clsx(styles.links, styles.text_sm)}>
          <div className={styles.column}>
            {navLinks.map((item) => (
              <a key={item.text} href={item.link} target="_blank" rel="noreferrer">
                {item.text}
              </a>
            ))}
          </div>
          <div className={clsx(styles.additionalContent, styles.text_md, styles.text_secondary)}>
            ©
            {' '}
            {dayjs().year()}
            {' '}
            Sephyre GmbH
          </div>
        </div>
        <div className={styles.social}>
          <div className={styles.column}>
            {links.map((item) => (
              <a key={item.text} href={item.link} target="_blank" rel="noreferrer">
                {item.text}
              </a>
            ))}
          </div>
          <div className={clsx(styles.additionalContent, 'row-with-gap')}>
            <SocialsContent />
          </div>
        </div>

        <div className={styles.mobileAdditionalContent}>
          <div className={clsx(styles.text_md, styles.text_secondary)}>
            ©
            {' '}
            {dayjs().year()}
            {' '}
            Sephyre GmbH
          </div>
          <div className="row-with-gap">
            <SocialsContent />
          </div>
        </div>

        <div className={styles.scrollTop}>
          <ScrollToTopButton />
        </div>
      </div>
    </div>
  );
}
